import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';

export const StyledBagelcodeBundle = styled.div`
  width: 100%;
  max-width: 400px;
  height: 148px;
  aspect-ratio: 1/1.31;
  position: relative;
  font-family: var(--font-family), Arial;
  font-weight: bold;

  .container {
    width: 100%;
    height: 100%;
    max-height: 170px; // safari fix
    display: flex;
    flex-direction: column;
    border-radius: 7px;
    background: var(--bundle-border-color);

    .product {
      height: 148px;
      border-radius: 7px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      padding: 2px;
      background: ${(props: any) =>
        props.backgroundSrc
          ? `url("${props.backgroundSrc}")`
          : createGradientOrSolid(props.backgroundColor)};
      background-clip: content-box;
      background-size: cover;
      background-position: center;

      .badge-wrapper {
        position: absolute;
      }

      .amount {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: ${(props: any) => props.productColor};
        text-shadow: 1.75px 2.625px 0 #191919, 1.616825px 0.669725px 0 #191919,
          1.237425px 1.237425px 0 #191919, 0.669725px 1.616825px 0 #191919,
          2.625px 1.75px 0 #191919, -0.669725px 1.616825px 0 #191919,
          -1.237425px 1.237425px 0 #191919, -1.616825px 0.669725px 0 #191919,
          -1.75px 0 0 #191919, -1.616825px -0.669725px 0 #191919,
          -1.237425px -1.237425px 0 #191919, -0.669725px -1.616825px 0 #191919,
          0 -1.75px 0 #191919, 0.669725px -1.616825px 0 #191919,
          1.237425px -1.237425px 0 #191919, 1.616825px -0.669725px 0 #191919;
        text-align: left;
        font-size: 1.25rem;
        line-height: normal;

        .time-based {
          font-size: 0.75rem;
          font-style: normal;
          font-weight: 400;
          color: #ffffff;
          line-height: normal;
          position: relative;
          text-shadow: 1.75px 2.625px 0 #191919, 1.616825px 0.669725px 0 #191919,
            1.237425px 1.237425px 0 #191919, 0.669725px 1.616825px 0 #191919,
            2.625px 1.75px 0 #191919, -0.669725px 1.616825px 0 #191919,
            -1.237425px 1.237425px 0 #191919, -1.616825px 0.669725px 0 #191919,
            -1.75px 0 0 #191919, -1.616825px -0.669725px 0 #191919,
            -1.237425px -1.237425px 0 #191919, -0.669725px -1.616825px 0 #191919,
            0 -1.75px 0 #191919, 0.669725px -1.616825px 0 #191919,
            1.237425px -1.237425px 0 #191919, 1.616825px -0.669725px 0 #191919;
        }

        .stroked {
          font-size: 0.75rem;
          font-style: normal;
          font-weight: 400;
          color: #6a6a6a;
          line-height: normal;
          position: relative;
          text-shadow: none;

          &::after {
            content: ' ';
            height: 2px;
            width: 130%;
            background: #d8232a;
            position: absolute;
            left: -15%;
            top: 50%;
          }
        }

        img {
          height: 14px;
          aspect-ratio: 1/1;
          margin: 0 4px 0 0;
        }
      }

      .image-container {
        display: flex;
        justify-content: center;
        overflow: hidden;
        align-items: center;
        margin: 11px auto 0;
        height: 51px;
        width: 61px;

        .image {
          max-width: 120px;
          height: 110%;
          width: 100%;
          object-fit: contain;
        }
      }
    }
  }

  .price-container {
    width: 100%;
    margin: 0 auto;

    .price {
      margin: 0 4px 4px 4px;
      border: 1px solid #000;
      width: auto;
      padding: 0 4px;
      border-radius: 6px;
      box-shadow: inset 0 -2px 0 0 rgba(0, 115, 0, 1);
      font-size: inherit;
      height: 28px;
      display: flex;
      align-items: center;

      .totalPrice {
        text-shadow: -1px -1px 0 #338908, 1px -1px 0 #338908, -1px 1px 0 #338908,
          1px 1px 0 #338908;
        align-items: center;
      }
    }
  }
` as any;
